import React from 'react';

// Individual map-pin marker at a given position / size / opacity
interface PinProps {
  cx: number;
  cy: number;
  scale?: number;
  opacity?: number;
  color?: string;
}

const MapPinSvg: React.FC<PinProps> = ({
  cx,
  cy,
  scale = 1,
  opacity = 1,
  color = '#F76443'
}) => {
  const w = 18 * scale;
  const h = 24 * scale;
  return (
    <g
      transform={`translate(${cx - w / 2}, ${cy - h}) scale(${scale})`}
      opacity={opacity}
    >
      {/* pin shape — teardrop */}
      <path
        d="M9 0C5.134 0 2 3.134 2 7c0 5.25 7 13 7 13s7-7.75 7-13c0-3.866-3.134-7-7-7z"
        fill={color}
      />
      <circle cx="9" cy="7" r="3" fill="white" />
      {/* shadow ellipse */}
      <ellipse cx="9" cy="21" rx="4" ry="1.2" fill="rgba(0,0,0,0.10)" />
    </g>
  );
};

// Variant: Pins — scattered map-pin markers on gray background
// Renders only the card content (no outer section/title wrapper)
const RewardsHubComingSoonPins: React.FC = () => (
  <div
    className="relative overflow-hidden rounded-xl border border-gray-200 bg-gray-100 shadow-sm"
    style={{ minHeight: 220 }}
  >
    {/* scattered pins as background decoration */}
    <svg
      className="absolute inset-0 h-full w-full"
      xmlns="http://www.w3.org/2000/svg"
      preserveAspectRatio="xMidYMid slice"
      viewBox="0 0 600 220"
    >
      {/* base ground color */}
      <rect width="600" height="220" fill="#f3f4f6" />

      {/* subtle road traces */}
      <line
        x1="0"
        y1="140"
        x2="600"
        y2="130"
        stroke="#e5e7eb"
        strokeWidth="8"
      />
      <line x1="0" y1="70" x2="600" y2="80" stroke="#e5e7eb" strokeWidth="5" />
      <line
        x1="200"
        y1="0"
        x2="190"
        y2="220"
        stroke="#e5e7eb"
        strokeWidth="5"
      />
      <line
        x1="420"
        y1="0"
        x2="410"
        y2="220"
        stroke="#e5e7eb"
        strokeWidth="8"
      />

      {/* background / far pins */}
      <MapPinSvg cx={60} cy={80} scale={0.65} opacity={0.25} color="#F76443" />
      <MapPinSvg cx={130} cy={55} scale={0.55} opacity={0.2} color="#9ca3af" />
      <MapPinSvg cx={490} cy={65} scale={0.6} opacity={0.22} color="#F76443" />
      <MapPinSvg
        cx={550}
        cy={100}
        scale={0.55}
        opacity={0.18}
        color="#9ca3af"
      />
      <MapPinSvg cx={45} cy={170} scale={0.6} opacity={0.25} color="#9ca3af" />
      <MapPinSvg
        cx={520}
        cy={175}
        scale={0.65}
        opacity={0.22}
        color="#F76443"
      />

      {/* mid-ground pins */}
      <MapPinSvg
        cx={100}
        cy={145}
        scale={0.85}
        opacity={0.45}
        color="#F76443"
      />
      <MapPinSvg cx={350} cy={50} scale={0.8} opacity={0.4} color="#9ca3af" />
      <MapPinSvg
        cx={460}
        cy={155}
        scale={0.85}
        opacity={0.45}
        color="#F76443"
      />
      <MapPinSvg cx={240} cy={170} scale={0.8} opacity={0.4} color="#9ca3af" />

      {/* foreground / anchor pins — full opacity */}
      <MapPinSvg cx={160} cy={120} scale={1.2} opacity={0.75} color="#F76443" />
      <MapPinSvg cx={440} cy={115} scale={1.1} opacity={0.7} color="#F76443" />

      {/* radial fade overlay so center reads cleanly */}
      <radialGradient id="pins-fade" cx="50%" cy="50%" r="45%">
        <stop offset="0%" stopColor="#f3f4f6" stopOpacity="0.92" />
        <stop offset="100%" stopColor="#f3f4f6" stopOpacity="0" />
      </radialGradient>
      <rect width="600" height="220" fill="url(#pins-fade)" />
    </svg>

    {/* content */}
    <div className="relative z-10 flex h-full flex-col items-center justify-center px-6 py-12 text-center">
      <div className="mb-4 flex h-14 w-14 items-center justify-center rounded-full bg-white shadow-md">
        <svg
          xmlns="http://www.w3.org/2000/svg"
          viewBox="0 0 24 24"
          fill="#F76443"
          className="h-8 w-8"
        >
          <path
            fillRule="evenodd"
            d="M11.54 22.351l.07.04.028.016a.76.76 0 00.723 0l.028-.015.071-.041a16.975 16.975 0 001.144-.742 19.58 19.58 0 002.683-2.282c1.944-2.079 3.218-4.402 3.218-7.327a7.5 7.5 0 10-15 0c0 2.925 1.274 5.248 3.218 7.327a19.579 19.579 0 002.682 2.282 16.932 16.932 0 001.145.742zM12 13.5a3 3 0 100-6 3 3 0 000 6z"
            clipRule="evenodd"
          />
        </svg>
      </div>

      <span
        className="mb-3 inline-flex items-center rounded-full px-3 py-0.5 text-xs font-semibold uppercase tracking-wider text-white"
        style={{ background: '#F76443' }}
      >
        Coming Soon
      </span>

      <p className="text-base font-semibold text-gray-700">
        Upgrading to map based for your region.
      </p>
      <p className="mt-1 text-sm text-gray-500">
        Find and redeem rewards at locations around you.
      </p>
    </div>
  </div>
);

export default RewardsHubComingSoonPins;
